import { render, staticRenderFns } from "./CreateAssignRulesModal.vue?vue&type=template&id=5a80d34b&"
import script from "./CreateAssignRulesModal.vue?vue&type=script&lang=ts&"
export * from "./CreateAssignRulesModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateAssignRulesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports